import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import PlanSelectionDialog from '@/plans/common/plan-selection-dialog.vue';
import { pageConfig } from '@/common/service/page-config';
import {
  PLAN_SELECTION_DIALOG_WIDTH,
  PLAN_SELECTION_DIALOG_HEIGHT,
  resizeModalDialogIniFrame,
  closeiFrameContainerLoading,
} from '@/utils/modal-utils';
import { MODAL_ENTRY_SOURCE_MAP } from '@/common/constants';
import { getPlatformFromUrl, TRACKING_CONSTANT_KEYS } from '@/aspects/trackings';

const PLAN_SELECTION_DIALOG_PAGE_FROM_LIST = ['scheduler', 'clips'];

export const openPlanSelectionDialogInModal = ({ from, entry } = {}) => {
  if (from === 'scheduler') {
    resizeModalDialogIniFrame({
      width: PLAN_SELECTION_DIALOG_WIDTH,
      height: PLAN_SELECTION_DIALOG_HEIGHT,
    });
  }
  setTimeout(() => {
    closeiFrameContainerLoading();
    const planSelectionDialogInstance = new ServiceConfirm(PlanSelectionDialog);
    planSelectionDialogInstance.confirm({ from, entry });
  }, 10);
};

export const isNeedOpenPlanSelectionDialog = (configs) => {
  try {
    const { pageType, pageFrom, entrySource } = Object.assign({}, pageConfig, configs);
    if (pageType !== "modal") {
      return false;
    }
    if (!PLAN_SELECTION_DIALOG_PAGE_FROM_LIST.includes(pageFrom)) {
      return false;
    }
    if (!Object.values(MODAL_ENTRY_SOURCE_MAP).includes(entrySource)) {
      return false;
    }
    return true;
  } catch (error) {
    console.error('isNeedOpenPlanSelectionDialog error: ', error);
    return false;
  }
};

export const openPlanSelectionDialogIfNeeded = () => {
  const { pageFrom, entrySource } = pageConfig;

  if (!isNeedOpenPlanSelectionDialog()) {
    return;
  }

  openPlanSelectionDialogInModal({ from: pageFrom, entry: entrySource });
};

/**
 * Build the page version string for plan selection dialog tracking.
 * Combines 'standalone in-product', platform from URL (via getPlatformFromUrl), and 'select a plan'.
 * @returns {string} Space-separated string, e.g. 'standalone in-product web select a plan'
 */
export const getPlanSelectionDialogPageVersion = () => {
  return [TRACKING_CONSTANT_KEYS.StandaloneInProduct, getPlatformFromUrl(), TRACKING_CONSTANT_KEYS.SelectAPlan]
    .filter(Boolean)
    .join(' ');
};